import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["title"]
const _hoisted_2 = { key: 2 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_svg_icon = _resolveComponent("svg-icon")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.icon)
      ? (_openBlock(), _createBlock(_component_svg_icon, {
          key: 0,
          "icon-class": _ctx.icon
        }, null, 8, ["icon-class"]))
      : _createCommentVNode("", true),
    (_ctx.title && _ctx.title.length > 5)
      ? (_openBlock(), _createElementBlock("span", {
          key: 1,
          title: _ctx.title
        }, _toDisplayString(_ctx.title), 9, _hoisted_1))
      : (_ctx.title)
        ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.title), 1))
        : _createCommentVNode("", true)
  ]))
}